var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64398 23.9999H7.65347V11.6489L0.5 6.20605V21.8437C0.5 23.0369 1.46891 23.9999 2.64398 23.9999Z",
    fill: "#6A41A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8467 24.0003H29.8562C31.0518 24.0003 32.0001 23.0164 32.0001 21.8232V6.18555L24.8467 11.6284V24.0003Z",
    fill: "#6A41A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8467 2.18685V11.628L32.0001 6.18523V3.27541C32.0001 0.574936 28.9697 -0.953241 26.8463 0.658672L24.8467 2.18685Z",
    fill: "#A989D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65332 11.6492V2.20801L16.2499 8.76033L24.8464 2.20801V11.6492L16.2499 18.1806L7.65332 11.6492Z",
    fill: "#6A41A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.27576V6.18557L7.65347 11.6284V2.18719L5.6538 0.659016C3.53043 -0.952897 0.5 0.596214 0.5 3.27576Z",
    fill: "#523280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.5f5ddd16e0c70fc3f5c21e1dd2dc5215.svg";
export { ForwardRef as ReactComponent };